export type {
  BaseModalProps,
  BaseModalHeaderProps,
  BaseModalFooterProps,
  BaseModalContentProps,
  BaseModalHandle,
} from './types'
export { BaseModalSize } from './types'
export { default as BaseModal } from './BaseModal'
export { default as BaseModalFooter } from './BaseModalFooter'
export { default as BaseModalHeader } from './BaseModalHeader'
export { default as BaseModalContent } from './BaseModalContent'
